import { combineReducers } from 'redux'
import darioSystemDataReducer from './darioSystemData/reducers'
import coachSystemDataReducer from './coachSystemData/reducers'
import notesForPatientReducer from './notes/reducers'
import patientQuestionnairesReducer from './questionnaire/reducers'
import patientAccountDataReducer from './patientAccountData/reducers'
import patientAccountOrdersReducer from './patientAccountOrders/reducers'
import checklistReducer from './checklist/reducers'
import tasksReducer from './tasks/reducers'
import timelineReducer from './timeline/reducers'
import reportsReducer from './reports/reducers'
import { PatientDashboardState } from '../../../types/patients'
import clinicalReducer from './clinical/reducers'
import logBookReducer from './logBook/reducers'
import chartReducer from './chart/reducer'

export default combineReducers<PatientDashboardState>({
	darioSystemData: darioSystemDataReducer,
	coachSystemData: coachSystemDataReducer,
	notesForPatient: notesForPatientReducer,
	questionnaires: patientQuestionnairesReducer,
	pacientAccountData: patientAccountDataReducer,
	pacientAccountOrders: patientAccountOrdersReducer,
	checklist: checklistReducer,
	tasks: tasksReducer,
	clinical: clinicalReducer,
	logBook: logBookReducer,
	reports: reportsReducer,
	timeline: timelineReducer,
	chart: chartReducer
})
